import { CoverLetter, Resume } from 'packages/types'
import { selectors } from 'builder/modules/init'
import { templateGroups } from 'builder/utils/templateGroups'
import { TemplateCategories, TemplateChangeHandler } from 'builder/modules/resumeEditor'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { TemplateGroupHeader, TemplateGroup } from './styles'
import { TemplatesList } from './TemplatesList'

type Props = {
  selectedTemplates: string[]
  selectedCategory: `${TemplateCategories}`
  currentDocument: Resume | CoverLetter
  updateTemplate: TemplateChangeHandler
}

export const TemplatesPreviewList = (props: Props): JSX.Element => {
  const { selectedTemplates, selectedCategory, currentDocument, updateTemplate } = props

  const editorState = useTypedSelector(state => state.generalEditor)
  const locale = useTypedSelector(selectors.locale)

  const templateGroupsList = templateGroups(editorState, currentDocument.type, locale)
  const isDataLoaded = currentDocument && editorState.isLoaded

  return (
    <>
      {isDataLoaded &&
        templateGroupsList.map(({ title, templates }) => (
          <TemplateGroup key={title}>
            {templateGroupsList.length > 1 && <TemplateGroupHeader>{title}</TemplateGroupHeader>}
            <TemplatesList
              templates={templates}
              selectedTemplates={selectedTemplates}
              selectedCategory={selectedCategory}
              updateTemplate={updateTemplate}
              currentDocument={currentDocument}
            />
          </TemplateGroup>
        ))}
    </>
  )
}
